import { useEffect, useState, useRef, useContext } from "react";
import { Link } from "react-router-dom";

import { LayoutContext } from "../layout/";

import { getAllProducts } from '../preinvoice/storage';

import Loader from "../loader";
import { getEndpoint } from "../helper";

export default function Invoices(props) {
    const { setPageTitle } = useContext(LayoutContext);

    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    const formatNumber = n => n && n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    const fetchData = async () => {
        const productIds = getAllProducts().map(x => x.id).join(',');

        try {
            const response = await fetch(getEndpoint(`/api/android/brand/getby?productIds=${productIds}`));
            const json = await response.json();
            const data = {
                items: json.data,
                totalPrice: 0,
                totalDiscount: 0,
                payablePrice: 0
            }

            for (const item of json.data) {
                data.totalPrice += (item.oldPrice * item.quantity);
                data.payablePrice += (item.price * item.quantity);
            }

            data.totalDiscount = data.totalPrice - data.payablePrice;

            setData(data);

        } catch (err) {
            if (err.name !== "AbortError") setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const BrandBox = ({ id, title, price, oldPrice, discount, picture }) => {
        const Img = () => {
            if (picture && picture.length > 0) return <img src={getEndpoint(`/uploads/shop/brand/${picture}`)} />;

            return <img src={getEndpoint('/pwa/img/no_pic_750x750.jpg')} />;
        }

        return (
            <Link className='box p-r d-f bc-w bw-1 bc--n3 br-3 mb-2' to={`/preinvoice2/${id}`}>
                <div className='fsh-0 fg-0' style={{ backgroundColor: '#dddddd', width: '28%' }}>
                    <Img />
                </div>
                <div className='px-2 pt-2 w-100 d-f fd-c'>
                    <div className='lh-2'>{title}</div>
                    <div className='d-f ai-c mt-a'>
                        <div className='fw-600'>
                            <div className='d-f ai-c mt-1'>
                                <div className='fs-3' style={{ color: '#9c9c9c', textDecorationLine: 'line-through' }}>{formatNumber(oldPrice)}</div>
                                &nbsp;
                                <div style={{ color: '#9c9c9c', fontSize: '.8em' }}>ریال</div>
                            </div>
                            <div className='d-f ai-c p-r _c-b_b' style={{ top: '-.5em' }}>
                                <div className='fs-3' style={{}}>{formatNumber(price)}</div>
                                &nbsp;
                                <div style={{ fontSize: '.8em' }}>ریال</div></div>
                        </div>
                        <div className='ta-c _bc-g-d c-w px-1 br-4 mr-a lh-2'>
                            <div className='d-l fs-3'>{discount}%</div>
                            <div style={{ fontSize: '.8em' }}>تخفیف</div>
                        </div>
                    </div>
                </div>
            </Link>
        );
    }

    useEffect(() => {
        setPageTitle('پیش فاکتورها');

        setLoading(true);
        fetchData();
    }, []);

    if (loading) return <Loader />;
    if (error) return <p>Error: {error}</p>;

    return (
        <>
            <div className='p-2' style={{ backgroundColor: '#f5f5f5', paddingBottom: '9rem' }}>
                {data.items.map(x => {
                    return (
                        <BrandBox
                            key={x.id}
                            id={x.id}
                            title={x.title}
                            price={x.price}
                            oldPrice={x.oldPrice}
                            discount={x.discount}
                            picture={x.picture}
                        />
                    )
                })}
            </div>
        </>
    );
}